
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface AgentPurposeStepProps {
  agentData: any;
  setAgentData: (data: any) => void;
}

const AgentPurposeStep: React.FC<AgentPurposeStepProps> = ({ agentData, setAgentData }) => {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="agentName">Agent Name</Label>
        <Input
          id="agentName"
          placeholder="Give your agent a name"
          value={agentData.name}
          onChange={(e) => setAgentData({ ...agentData, name: e.target.value })}
          className="border-[#0EA5E9]/30"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="agentPurpose">Agent Purpose</Label>
        <Textarea
          id="agentPurpose"
          placeholder="Describe what this agent is and what it will do"
          value={agentData.purpose}
          onChange={(e) => setAgentData({ ...agentData, purpose: e.target.value })}
          className="min-h-[100px] border-[#0EA5E9]/30"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="llmService">LLM Service</Label>
        <Select 
          value={agentData.llmService} 
          onValueChange={(value) => setAgentData({ ...agentData, llmService: value })}
        >
          <SelectTrigger id="llmService" className="border-[#0EA5E9]/30">
            <SelectValue placeholder="Select an LLM service provider" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="openai">OpenAI (GPT-4o)</SelectItem>
            <SelectItem value="gemini">Google Gemini</SelectItem>
            <SelectItem value="claude">Anthropic Claude</SelectItem>
            <SelectItem value="custom_url">Custom API Endpoint</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default AgentPurposeStep;
